module.exports = __webpack_public_path__ + "img/battery-groupe.fd78656e.svg";